import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Menu1 from "./Menu/Menu1";
import Menu2 from "./Menu/Menu2";
import Menu3 from "./Menu/Menu3";
import Menu4 from "./Menu/Menu4";
import Menu5 from "./Menu/Menu5";
import Menu6 from "./Menu/Menu6";
import LoadingSetData from "../../TESTPage/LoadingSetData";
import FadeIn from "react-fade-in/lib/FadeIn";

const SetDataLar = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const paramName = params.get("menuName");

  const [menu, setMenu] = useState(paramName);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  useEffect(() => {
    setMenu(paramName)
  },[paramName])

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingSetData />
      ) : (
        <FadeIn>
          <Container fluid>
            <Row>
              <Col xxl={12}>
                {menu === "1" ? (
                  <Menu1 menu={1} />
                ) : menu === "2" ? (
                  <Menu2 menu={2} />
                ) : menu === "3" ? (
                  <Menu3 menu={3} />
                ) : menu === "4" ? (
                  <Menu4 menu={4} />
                ) : menu === "5" ? (
                  <Menu5 menu={5} />
                ) : menu === "6" ? (
                  <Menu6 menu={6} />
                ) : (
                  <Menu1 menu={1}/>
                )}
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default SetDataLar;
